import Divider from '@material-ui/core/Divider/Divider'
import List from '@material-ui/core/List/List'
import ListItem from '@material-ui/core/ListItem/ListItem'
import ListItemText from '@material-ui/core/ListItemText/ListItemText'

import { getTranslate } from '../../localization'
import { LocalizedNavLink } from '../../routes/localizedRoutes'
import { useStyles } from './styles/SettingMenu.styles'

const SettingMenu = () => {
  const classes = useStyles()
  return (
    <div className={classes.mianDiv}>
      <List component="nav">
        <ListItem
          button
          activeClassName={classes.activeListItem}
          component={LocalizedNavLink}
          to="/settings/basic-info">
          <ListItemText primary={getTranslate('Basic Info')} />
        </ListItem>
        <Divider />
        <ListItem
          button
          activeClassName={classes.activeListItem}
          component={LocalizedNavLink}
          to="/settings/change-password">
          <ListItemText primary={getTranslate('Change Password')} />
        </ListItem>
        <Divider />
      </List>
    </div>
  )
}
export default SettingMenu
